// Nombres de rubro para mostrar. Vienen de `/v1/directory/categories` tal como los cargó el scraper
// y algunos llegan sin tilde («Salon de belleza»). No se cambian en la API ni en los slugs: solo se
// corrigen al mostrarlos, palabra por palabra, con las palabras de rubro conocidas.

const ACCENTED_WORDS = {
  salon: 'salón',
  estetica: 'estética',
  peluqueria: 'peluquería',
  barberia: 'barbería',
  manicuria: 'manicuría',
  depilacion: 'depilación',
  podologo: 'podólogo',
  podologa: 'podóloga',
  podologico: 'podológico',
  podologia: 'podología',
  cosmiatria: 'cosmiatría',
  cosmetologia: 'cosmetología',
  clinica: 'clínica',
  pestanas: 'pestañas',
  unas: 'uñas'
};

const matchCase = (original, replacement) =>
  original[0] === original[0].toUpperCase() ? replacement[0].toUpperCase() + replacement.slice(1) : replacement;

/** «Salon de belleza» → «Salón de belleza». Lo que ya trae tilde o no se conoce queda igual. */
export function categoryDisplayName(name) {
  if (!name) return '';
  return String(name)
    .trim()
    .replace(/[A-Za-z]+/g, (word) => {
      const fixed = ACCENTED_WORDS[word.toLowerCase()];
      return fixed ? matchCase(word, fixed) : word;
    });
}

// Bajada de cada rubro en el home. Las que faltan usan DEFAULT_CATEGORY_DESCRIPTION.
const CATEGORY_DESCRIPTIONS = {
  peluqueria: 'Corte, color, alisados y tratamientos',
  barberia: 'Corte, barba y grooming masculino',
  'centro-de-estetica': 'Tratamientos faciales, limpieza y más',
  manicuria: 'Manicura, uñas esculpidas y nail art',
  unas: 'Manicura, uñas esculpidas y nail art',
  manicura: 'Esmaltado, semipermanente y capping',
  manicurista: 'Esmaltado, semipermanente y capping',
  'salon-de-belleza': 'Servicios integrales de belleza',
  depilacion: 'Depilación láser y cera',
  'centro-de-depilacion': 'Depilación láser, definitiva y con cera',
  podologo: 'Cuidado de pies y uñas encarnadas',
  'centro-podologico': 'Cuidado de pies y uñas encarnadas',
  'centro-para-el-cuidado-de-los-pies': 'Pedicuría y cuidado de los pies',
  maquilladora: 'Maquillaje social, para eventos y novias',
  'salon-de-pestanas': 'Extensiones, lifting y laminado de pestañas',
  pestanas: 'Extensiones, lifting y laminado de pestañas',
  'bar-de-cejas': 'Diseño, perfilado y laminado de cejas',
  cosmiatra: 'Tratamientos faciales y cuidado de la piel',
  cosmiatria: 'Tratamientos faciales y cuidado de la piel',
  'clinica-de-maquillaje-permanente': 'Microblading y micropigmentación',
  'escuela-de-peluqueros': 'Cursos y formación en peluquería',
  masajes: 'Descontracturantes, relajantes y más',
  'tratamientos-faciales': 'Limpieza facial, peelings e hidratación'
};

export const DEFAULT_CATEGORY_DESCRIPTION = 'Profesionales y negocios cerca tuyo';

export const categoryDescription = (slug) => CATEGORY_DESCRIPTIONS[slug] || DEFAULT_CATEGORY_DESCRIPTION;
